import envConfig from '../environments/envConfig';
import returnApiHeaders from './headers';

const environment = process.env.REACT_APP_ENV;
const baseUrl = envConfig[environment].REACT_CORE_API_URL;

const getStoreData = async () => {
  try {
    const response = await fetch(`${baseUrl}/stores`, {
      headers: returnApiHeaders('GET'),
    });
    if (!response.ok) {
      throw new Error('Error on GET stores');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};
//Can add more endpoints here
export { getStoreData };
